//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
SPLM.Preferences.Font = Object.freeze({
    "Invisible" : "Invisible", "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Original" : "Original", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.Preferences.Width = Object.freeze({
    "Original" : "Original", "Thin" : "Thin", "Normal" : "Normal", "Thick" : "Thick", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine"});

SPLM.Preferences.GdtOption = Object.freeze({
    "None" : "None", "InDrawingPlane" : "InDrawingPlane", "FromModelView" : "FromModelView"});

SPLM.Preferences.PmiOption = Object.freeze({
    "None" : "None", "FromModelView" : "FromModelView", "InDrawingPlaneFromView" : "InDrawingPlaneFromView", "InDrawingPlaneFromPart" : "InDrawingPlaneFromPart"});

SPLM.Preferences.ReferenceSetBehavior = Object.freeze({
    "None" : "None", "Partial" : "Partial", "All" : "All"});

SPLM.Preferences.GeneralViewRepresentationOption = Object.freeze({
    "Exact" : "Exact", "SmartLightweight" : "SmartLightweight", "Lightweight" : "Lightweight", "PreNx85Exact" : "PreNx85Exact"});

SPLM.Preferences.GeneralViewQualityOption = Object.freeze({
    "Coarse" : "Coarse", "Medium" : "Medium", "Fine" : "Fine"});

SPLM.Preferences.GeneralExtractedEdgesOption = Object.freeze({
    "None" : "None", "Associative" : "Associative", "NonAssociative" : "NonAssociative"});

SPLM.Preferences.GeneralWireframeColorSourceOption = Object.freeze({
    "FromBody" : "FromBody", "FromFace" : "FromFace"});

SPLM.Preferences.GeneralDisplayIdOption = Object.freeze({
    "None" : "None", "Orientation" : "Orientation", "Name" : "Name"});

SPLM.Preferences.DetailBoundaryOption = Object.freeze({
    "Circular" : "Circular", "Rectangular" : "Rectangular"});

SPLM.Preferences.HiddenLineInterferingSolidsOption = Object.freeze({
    "None" : "None", "Yes" : "Yes", "InterferenceCurves" : "InterferenceCurves"});

SPLM.Preferences.IncludeModelCurvesOption = Object.freeze({
    "No" : "No", "Yes" : "Yes"});

SPLM.Preferences.HiddenLineSmallFeatureOption = Object.freeze({
    "ShowAll" : "ShowAll", "Simplify" : "Simplify", "Hide" : "Hide"});

SPLM.Preferences.ShadingRenderingStyleOption = Object.freeze({
    "FullyShaded" : "FullyShaded", "PartiallyShaded" : "PartiallyShaded", "Wireframe" : "Wireframe"});

SPLM.Preferences.ShadingToleranceOption = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "UltraFine" : "UltraFine", "Customize" : "Customize"});

SPLM.Preferences.GeneralToleranceOption = Object.freeze({
    "Coarse" : "Coarse", "Medium" : "Medium", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "Customize" : "Customize"});

SPLM.Preferences.AngleFormat = Object.freeze({
    "FractionalDegrees" : "FractionalDegrees", "DegreesMinutes" : "DegreesMinutes", "DegreesMinutesSeconds" : "DegreesMinutesSeconds", "WholeDegrees" : "WholeDegrees"});

SPLM.Preferences.DecimalPointCharacter = Object.freeze({
    "Period" : "Period", "Comma" : "Comma"});

SPLM.Preferences.GeneralViewLockmethodOption = Object.freeze({
    "None" : "None", "Snapshot" : "Snapshot", "Complete" : "Complete"});

export default SPLM;